import { render } from "./EthicsPolicy.vue?vue&type=template&id=716b9670"
import script from "./EthicsPolicy.vue?vue&type=script&lang=js"
export * from "./EthicsPolicy.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__